import React from "react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_harvest-management-4/artifacts/u7bo8k7c_PCW_LOGO.webp";

/**
 * Pullman Child Welfare logo — handshake forming a heart on navy circle.
 * `size` is the rendered square size in px.
 */
export default function Logo({ size = 40, className = "", style = {} }) {
  return (
    <img
      src={LOGO_URL}
      alt="Pullman Child Welfare logo"
      width={size}
      height={size}
      className={`rounded-full shrink-0 ${className}`}
      style={{ width: size, height: size, objectFit: "cover", ...style }}
    />
  );
}
